import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fullUpdate } from '@store/slice/mediaManagerSlice'
import { get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import Div from '@ui/layout/Div'
import MediaManagerBar from '@scene/window/media-manager/__partials/MediaManagerBar'
import MediaManagerContent from '@scene/window/media-manager/__partials/MediaManagerContent'

const MediaManager = () => {
  const { medias } = useSelector(state => state.mediaManager)
  const { mission } = useSelector(state => state.main)
  const dispatch = useDispatch()
  const [t] = useTranslation('common')

  const getMedias = () => {
    get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/photos`, response => {
      const { code, missionPhotos } = response
      if (code === 200) {
        dispatch(fullUpdate({ medias: { ...missionPhotos } }))
      }
    })
  }

  useEffect(() => {
    if (!medias) {
      getMedias()
    }
  }, [medias])

  return (
    <Div cssClass='media-manager'>
      <h2 className='zone-title'>{t('titles.medias')}</h2>
      {
        medias
          ? <Div cssClass='columns'>
            <MediaManagerBar />
            <MediaManagerContent />
          </Div>
          : <></>
      }
    </Div>
  )
}

export default MediaManager